import(/* webpackMode: "eager" */ "/home/ubuntu/aether/platform/board/src/app/global-error.tsx");
